import { SpinResponse } from '@cgs/data-access';
import { Lazy } from '@cgs/shared';
import {
  EndFreeSpinsPopupController,
  GAME_STATE_MACHINE_PROVIDER_TOKEN,
  GameStateMachine,
  IGameStateMachineProvider,
  RegularSpinsSoundModel,
  RegularSpinsSoundModelComponent,
  T_RegularSpinsSoundModelComponent,
  GAME_WIN_COMPONENT_TOKEN,
  GameWinComponent,
} from '@cgs/machines';

export class CorsicaEndFreeSpinsPopupController extends EndFreeSpinsPopupController {
  private readonly regularSpinSoundModel: RegularSpinsSoundModel;
  private readonly gameStateMachine: GameStateMachine<SpinResponse>;
  private readonly gameWinComponent: Lazy<GameWinComponent>;

  constructor(...args: ConstructorParameters<typeof EndFreeSpinsPopupController>) {
    super(...args);

    this.regularSpinSoundModel = this.container.resolve<RegularSpinsSoundModelComponent>(
      T_RegularSpinsSoundModelComponent
    ).regularSpinSoundModel;

    this.gameStateMachine = this.container.resolve<IGameStateMachineProvider>(
      GAME_STATE_MACHINE_PROVIDER_TOKEN
    ).gameStateMachine;

    this.gameWinComponent = new Lazy(() =>
      this.container.resolve<GameWinComponent>(GAME_WIN_COMPONENT_TOKEN)
    );
  }

  public onEndFreeSpinShown(): void {
    super.onEndFreeSpinShown();

    this.regularSpinSoundModel.getSoundByName('end_free_spin').GoToState('stop');
    this.regularSpinSoundModel.getSoundByName('end_free_spin').GoToState('play');
    this.regularSpinSoundModel.getSoundByName('end_free_spin_loop').GoToState('stop');
    this.regularSpinSoundModel.getSoundByName('end_free_spin_loop').GoToState('play');
  }

  public onCloseClicked(): void {
    this.regularSpinSoundModel.getSoundByName('button_click').stop();
    this.regularSpinSoundModel.getSoundByName('button_click').play();
    super.onCloseClicked();
  }

  public onPopupClosed(): Promise<void> {
    this.gameWinComponent.call().addWin(this.gameStateMachine.curResponse.totalWin);
    this.regularSpinSoundModel.getSoundByName('end_free_spin').GoToState('stop');
    this.regularSpinSoundModel.getSoundByName('end_free_spin_loop').GoToState('stop');
    return super.onPopupClosed();
  }
}
